interface IOpenChat {
    type: 'OPEN_CHAT';
}

export function openChat(): IOpenChat {
    return {
        type: 'OPEN_CHAT',
    };
}

interface ICloseChat {
    type: 'CLOSE_CHAT';
}

export function closeChat(): ICloseChat {
    return {
        type: 'CLOSE_CHAT',
    };
}

export type IChatAction =
    | IOpenChat
    | ICloseChat;
